import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * Modal de confirmación para cancelar la edición/creación de evaluación
 */
const ConfirmacionCancelarModal = ({
  show,
  onConfirm,
  onCancel,
  currentStep,
  totalSteps,
  title = 'Confirmar cancelación',
  message,
  secondaryMessage,
  confirmLabel = 'Sí, cancelar',
  cancelLabel = 'Volver',
  icon = 'exclamation-triangle',
  iconColor = '#dc3545'
}) => {
  if (!show) return null;

  const mensajeBase = currentStep === totalSteps 
    ? '¿Desea cancelar? Los cambios realizados se perderán.'
    : '¿Desea cancelar esta acción? Perderá todos los cambios realizados.';

  const mensajePrincipal = message || mensajeBase;
  const mensajeSecundario = secondaryMessage || (currentStep === totalSteps
    ? 'Está en el paso final. ¿Seguro de que desea abandonar sin guardar?'
    : '');

  return (
    <div className="modal-overlay" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999
    }}>
      <div className="modal-content" style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '30px',
        maxWidth: '450px',
        width: '100%',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12), 0 4px 12px rgba(0, 0, 0, 0.08)',
        border: '1px solid rgba(0, 0, 0, 0.06)',
        animation: 'slideIn 0.3s ease-out'
      }}>
        <style>{`
          @keyframes slideIn {
            from {
              opacity: 0;
              transform: translateY(-20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}</style>
        <div className="modal-header" style={{ marginBottom: '20px' }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            fontSize: '18px',
            fontWeight: '600',
            color: iconColor
          }}>
            <FontAwesomeIcon icon={icon} />
            {title}
          </div>
        </div>

        <div className="modal-body" style={{ marginBottom: '25px', color: '#333', lineHeight: '1.6' }}>
          <p style={{ margin: 0, fontSize: '15px' }}>{mensajePrincipal}</p>
          {mensajeSecundario && (
            <p style={{ marginTop: '10px', fontSize: '14px', color: '#666' }}>
              {mensajeSecundario}
            </p>
          )}
        </div>

        <div className="modal-footer" style={{
          display: 'flex',
          gap: '12px',
          justifyContent: 'center'
        }}>
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={onCancel}
            style={{ 
              minWidth: '110px',
              border: '1.5px solid #ccc',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.borderColor = '#999';
              e.target.style.backgroundColor = '#f8f8f8';
            }}
            onMouseLeave={(e) => {
              e.target.style.borderColor = '#ccc';
              e.target.style.backgroundColor = 'white';
            }}
          >
            <FontAwesomeIcon icon="arrow-left" style={{ marginRight: '8px' }} />
            {cancelLabel}
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={onConfirm}
            style={{ minWidth: '130px' }}
          >
            <FontAwesomeIcon icon="times" style={{ marginRight: '8px' }} />
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmacionCancelarModal;
